const SeoLocalization = {
    en: {
        title: "Stellar Imperiums - An epic space adventure",
        description: "Explore Stellar Imperiums, a deep-space strategy game where every choice shapes the galaxy. Coming soon.",
    },
    fr: {
        title: "Stellar Imperiums - Une aventure spatiale épique",
        description: "Explorez Stellar Imperiums, un jeu de stratégie interstellaire où chaque décision façonne la galaxie. Bientôt disponible.",
    },
    de: {
        title: "Stellar Imperiums - Ein episches Weltraumabenteuer",
        description: "Erkunde Stellar Imperiums, ein tiefgehendes Strategiespiel im Weltall, in dem jede Entscheidung die Galaxie formt. Bald verfügbar.",
    },
    es: {
        title: "Stellar Imperiums - Una aventura espacial épica",
        description: "Explora Stellar Imperiums, un juego de estrategia en el espacio profundo donde cada elección da forma a la galaxia. Próximamente.",
    },
    zh: {
        title: "Stellar Imperiums - 史诗级太空冒险",
        description: "探索 Stellar Imperiums，这是一款深度太空策略游戏，每一个决定都会影响银河系。即将推出。",
    },
    ru: {
        title: "Stellar Imperiums - Эпическое космическое приключение",
        description: "Исследуйте Stellar Imperiums, стратегическую игру в глубоком космосе, где каждое решение формирует галактику. Скоро в продаже.",
    },
    jp: {
        title: "Stellar Imperiums - 壮大な宇宙冒険",
        description: "Stellar Imperiums を探索しよう。銀河を形作る選択肢が無限の深宇宙戦略ゲーム。近日公開。",
    },
    kr: {
        title: "Stellar Imperiums - 서사적인 우주 모험",
        description: "Stellar Imperiums를 탐험하세요. 깊은 우주 전략 게임에서 여러분의 선택이 은하계를 형성합니다. 곧 출시됩니다.",
    },
    it: {
        title: "Stellar Imperiums - Un'epica avventura spaziale",
        description: "Esplora Stellar Imperiums, un gioco di strategia spaziale in cui ogni scelta modella la galassia. Prossimamente.",
    },
    pl: {
        title: "Stellar Imperiums - Epicka przygoda kosmiczna",
        description: "Odkryj Stellar Imperiums, strategiczną grę osadzoną w przestrzeni kosmicznej, gdzie każda decyzja kształtuje galaktykę. Już wkrótce.",
    },
    pt: {
        title: "Stellar Imperiums - Uma aventura espacial épica",
        description: "Explore Stellar Imperiums, um jogo de estratégia no espaço profundo onde cada escolha molda a galáxia. Em breve.",
    },
    tr: {
        title: "Stellar Imperiums - Destansı bir uzay macerası",
        description: "Stellar Imperiums'u keşfedin, her seçimin galaksiyi şekillendirdiği derin uzay strateji oyunu. Yakında çıkıyor.",
    }
};

export default SeoLocalization;
